import gql from 'graphql-tag';

/**
 * Specifically used to fetch employee details of logged in user
 */
export const GET_EMPLOYEE_DETAILS = gql`
  query GET_EMPLOYEE_DETAILS($email: String!) {
    spEmployee(email: $email) {
      id
      firstName
      middleName
      lastName
      email

      departments {
        id
        name
        departmentCode
      }

      roles {
        id
        roleName
        roleTitle
      }

      offices {
        id
        name
        countryId
        countryName
      }

      officeAssignments {
        isDefault
        office {
          id
          name
        }
        officeRoles {
          id
          roleName
        }
      }
    }
    spEmployeeAuthorization {
      message
      data {
        id
        email
        officeIds
        roleNames
      }
    }
  }
`;

/**
 * Specifically used to fetch employee details by email in other parts of the codebase
 * where emloyee other than logged in user is required
 */
export const GET_EMPLOYEE_DETAILS_BY_EMAIL = gql`
  query GET_EMPLOYEE_DETAILS($email: String!) {
    spEmployeeByEmail(email: $email) {
      id
      firstName
      middleName
      lastName
      email
      phoneCode
      phoneValue
      hierarchyId
      hierarchyName
      departments {
        id
        name
        departmentCode
      }
      officeId
      officeName
      officeContinentId
      officeContinentName
      officeRegionId
      officeRegionName
      officeCountryId
      officeCountryName
      officeCityId
      officeCityName
      officeAddress
    }
  }
`;

/**
 * @todo TO BE REMOVED IN THE FUTURE
 * NOT BEING REMOVED YET BECAUSE OF REFERENCE IN THE CODEBASE
 */
export const GET_INSPECTOR_EMAIL_DETAILS = gql`
  query GET_INSPECTOR_EMAIL_DETAILS($email: String!) {
    inspector(email: $email) {
      data {
        id
        firstName
        middleName
        lastName
        email
        phoneCode
        phoneValue
      }
    }
  }
`;

/**
 * Used in coordinator details form v2 for jobs
 */
export const GET_EMPLOYEES_BY_OFFICE = gql`
  query GET_EMPLOYEES_BY_OFFICE($officeId: ID!) {
    spEmployees(officeId: $officeId) {
      data {
        id
        firstName
        middleName
        lastName
        email
        phoneCode
        phoneValue
        hierarchyId
        hierarchyName
        departments {
          id
          name
          departmentCode
        }
        officeId
        officeName
        officeContinentId
        officeContinentName
        officeRegionId
        officeRegionName
        officeCountryId
        officeCountryName
        officeCityId
        officeCityName
        officeAddress
      }
    }
  }
`;

/**
 * Used by the job orders coordinator picker to fetch ONLY coordinators for an
 * office. Filtering is done in the DB via roleMatchMode: EXCLUSIVE, so the
 * frontend only needs display fields and simply presents the result.
 */
export const GET_COORDINATORS_BY_OFFICE = gql`
  query GET_COORDINATORS_BY_OFFICE(
    $officeId: ID
    $roleNames: [String!]
    $roleMatchMode: EmployeeRoleMatchMode
  ) {
    spEmployeesByCommercialAttributes(
      officeId: $officeId
      roleNames: $roleNames
      roleMatchMode: $roleMatchMode
    ) {
      message
      data {
        id
        firstName
        middleName
        lastName
        email
        phoneCode
        phoneValue
      }
    }
  }
`;

/**
 * Used in inquiry details form for proposal coordinators, regional managers and heads of departments
 */
export const GET_EMPLOYEES_BY_COMMERCIAL_ATTRIBUTES = gql`
  query GET_EMPLOYEES_BY_COMMERCIAL_ATTRIBUTES(
    $departmentId: ID
    $roleNames: [String!]
    $officeId: ID
  ) {
    spEmployeesByCommercialAttributes(
      departmentId: $departmentId
      roleNames: $roleNames
      officeId: $officeId
    ) {
      message
      data {
        id
        firstName
        middleName
        lastName
        email

        departments {
          id
          name
          departmentCode
        }

        roles {
          id
          roleName
        }

        offices {
          id
          name
        }

        officeAssignments {
          isDefault
          office {
            id
            name
          }
          officeRoles {
            id
            roleName
          }
        }
      }
    }
  }
`;
